import React,{useState} from 'react'
import {Input} from "antd";
import AppButton from "../../../components/button";
import {connect} from "react-redux";
import {nextStage} from "../../../redux/actions";

const VotingTab = ({
    stage,
    ...props
}) =>{

    const [deposited,deposit] = useState(false)
    const [approved, approve] = useState(false)

    if(stage>=3){
        return <div className={'col center font-lg'}>
            Submitted to Community Voting

        </div>
    }

    if(approved){
        return(
            <div className={'col center font-lg'}>
                Your game has been approved for community voting
                <br/>
                <br/>
                <AppButton onClick={()=>{
                    props.dispatch(nextStage())
                }}>
                    SUBMIT TO COMMUNITY VOTING
                </AppButton>
            </div>
        )
    }

    if(deposited)
    {
        setTimeout(()=>approve(true),2000)

        return (
            <div className={'col center font-lg'}>
                50000 TAP bonds deposited. Waiting for approval
            </div>
        )
    }

    return(
        <div className={'col center'}>
        Submit Game for Community Voting
            <br/>
            <br/>
            <h3 className={'primary bold'}>
                50000 TAP Deposit Required
            </h3>
            <br/>
            <Input style={{width:280,textAlign:'center'}} placeholder={'Enter sponsor address'} />
            <br/>
            <br/>
            <div className={'font-lg'}>OR</div>
            <br/>
            <AppButton glow
            onClick={()=>{
                if(!deposited)
                    deposit(true)
                else if(!approved)
                    approve(true)
            }}
            >
                DEPOSIT TAP BOND
            </AppButton>
        </div>
    )
}

const mapStateToProps = (store) => ({
    stage: store.appReducer.stage

})


export default connect(mapStateToProps)(VotingTab)